import pageStyle from "./index.module.less";
import * as service from "@/views/ticket/service";

export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        lang: {
            type: [String, Number],
            default: ""
        },
        onClick: Function
    },
    data() {
        return {
            pageStyle,
            isTranslate: false
        };
    },
    methods: {
        async switchChange() {
            let translateData = [];
            if (this.isTranslate) {
                const textArrary = this.getStrText(this.value.list);
                const bath_query = {
                    list: textArrary,
                    from: "",
                    to: "en"
                };
                const list = await service.batch_translate(bath_query);
                translateData = list.list;
                this.onClick(translateData);
            } else {
                this.onClick(translateData);
            }
        },
        loopContent(val, translateContent) {
            let that = this;
            val.forEach(function(item) {
                if (item.children.length > 0) {
                    that.loopContent(item.children, translateContent);
                } else {
                    if (item.textContent) {
                        let obj = {};
                        item.translateStatus = "ing";
                        obj.content = item.textContent;
                        translateContent.push(obj);
                        let length = translateContent.length;
                        translateContent[length - 1].id = length.toString();
                    }
                }
            });
            return translateContent;
        },
        getStrText(val) {
            let translateContent = [];
            let data = this.loopContent(val, translateContent);
            return data;
        }
    }
};
